import type { ImportStatus } from "@atlas/shared";
import { apiGet } from "../lib/api-client";

export type { ImportStatus, ImportPhase } from "@atlas/shared";

export function fetchImportStatus(): Promise<ImportStatus> {
  return apiGet("/imports/status");
}
